import { TypographyOptions } from '@material-ui/core/styles/createTypography';

export const MuiTypography: Partial<TypographyOptions> = {
  fontFamily: 'CircularXX-Light, sans-serif',
  h1: {
    fontFamily: 'Lastik-Regular',
  },
  h2: {
    fontFamily: 'Lastik-Regular',
  },
  h3: {
    fontFamily: 'Lastik-Regular',
  },
  h4: {
    fontSize: 33,
    lineHeight: '40px',
    fontFamily: 'Lastik-Regular',
  },
  h5: {
    fontSize: 24,
    lineHeight: '30px',
    fontFamily: 'Lastik-Regular',
  },
  h6: {
    fontSize: 18,
    lineHeight: '30px',
    paddingBottom: '1rem',
    fontFamily: 'CircularXX-Medium, sans-serif',
  },
  body1: {
    fontSize: 18,
    lineHeight: '28px',
  },
  body2: {
    fontSize: 14,
    lineHeight: '21px',
  },
  subtitle1: {
    fontSize: 21,
    lineHeight: '28px',
  },
};
